import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseService } from '../../shared/services/base.service';
import { PatientUrl } from '../../shared/urls/patient.url';
import { ConsultationUrl } from '../../shared/urls/consultation.url';

@Injectable()
export class ViewInvoicesService {
  constructor(public baseService: BaseService) { }

  getAllConsultations(){
    return this.baseService.getAll(PatientUrl.PATIENT_GET_CONSULTATIONS);
  }

  getInvoicesByConsultationId(consultationId) {
    const url = ConsultationUrl.GET_CONSULTATION_INVOICES.replace("{id}",consultationId);
    return this.baseService.getAll(url);
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-invoices/view-invoices.service.ts